/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './reminder-options.reducer';

export const ReminderOptionsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const reminderOptionsEntity = useAppSelector(state => state.reminderOptions.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="reminderOptionsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.reminderOptions.detail.title">ReminderOptions</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.reminderOptions.id">Id</Translate>
            </span>
          </dt>
          <dd>{reminderOptionsEntity.id}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.reminderOptions.description">Description</Translate>
            </span>
          </dt>
          <dd>{reminderOptionsEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.reminderOptions.active">Active</Translate>
            </span>
          </dt>
          <dd>{reminderOptionsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.reminderOptions.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{reminderOptionsEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.reminderOptions.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{reminderOptionsEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.reminderOptions.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{reminderOptionsEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.reminderOptions.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{reminderOptionsEntity.cursor}</dd>
          <dt>
            <span id="reminderOptionsCode">
              <Translate contentKey="tinyMedicRestApp.reminderOptions.reminderOptionsCode">Reminder Options Code</Translate>
            </span>
          </dt>
          <dd>{reminderOptionsEntity.reminderOptionsCode}</dd>
        </dl>
        <Button tag={Link} to="/reminder-options" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/reminder-options/${reminderOptionsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ReminderOptionsDetail;
